var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.sub)?_c('CollectPayment',{attrs:{"subLister":_vm.subLister}}):_vm._e(),_c('div',{staticClass:"bottom",on:{"click":function($event){return _vm.btn()}}},[_c('p',[_vm._v("支付￥"+_vm._s(_vm.subList.price)+"/年")]),_c('p',[_vm._v("订阅文件版")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }